import { useCallback, useState } from 'react';

export default function usePullToRefresh({
  isLoading,
  refetch,
}: {
  isLoading: boolean;
  refetch: () => void;
}) {
  const [isPullToRefreshOngoing, setIsPullToRefreshOngoing] = useState(false);

  const onRefresh = useCallback(async () => {
    if (isLoading) {
      refetch();
      return;
    }
    setIsPullToRefreshOngoing(true);
    await refetch();
    setIsPullToRefreshOngoing(false);
  }, [isLoading, refetch]);

  return {
    onRefresh,
    refreshing: isPullToRefreshOngoing,
  };
}
